import React, { useEffect, useRef } from 'react';

const CodeRain = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const codeSnippets = [
      '01010101',
      '11001010',
      'console.log',
      'npm install',
      'git commit',
      'function()',
      'return true',
      'const x =',
      'if (true)',
      'while()',
      'for (let)',
      'import React',
      'export default',
      'async await',
      'try catch',
      'throw new',
      'class extends',
      'super()',
      'this.state',
      'setState()',
      'useEffect',
      'useState',
      'useRef',
      'useMemo',
      'useCallback',
      'map()',
      'filter()',
      'reduce()',
      'forEach()',
      'find()',
      'some()',
      'every()',
      'includes()',
      'indexOf()',
      'slice()',
      'splice()',
      'push()',
      'pop()',
      'shift()',
      'unshift()',
      'join()',
      'split()',
      'trim()',
      'toLowerCase',
      'toUpperCase',
      'replace()',
      'match()',
      'search()',
      'test()',
      'exec()',
      'JSON.parse',
      'JSON.stringify',
      'localStorage',
      'sessionStorage',
      'fetch()',
      'axios.get',
      'axios.post',
      'Promise.all',
      'await fetch',
      'await async',
      'try { }',
      'catch (e)',
      'finally { }',
      'throw new',
      'Error()',
      'console.warn',
      'console.error',
      'debugger',
      'break',
      'continue',
      'return',
      'yield',
      'export const',
      'import { }',
      'from \'',
      'require(',
      'module.exports',
      '__dirname',
      '__filename',
      'process.env',
      'NODE_ENV',
      'development',
      'production',
      'localhost',
      '127.0.0.1',
      '0.0.0.0',
      'PORT=40000',
      'DISCORD_',
      'CLIENT_ID',
      'CLIENT_SECRET',
      'GUILD_ID',
      'MAINTENANCE',
      'STATUS',
      'ONLINE',
      'OFFLINE',
      'MAINTENANCE',
      'OPERATIONAL',
      'DEGRADED',
      'OUTAGE',
      'INCIDENT',
      'RESOLVED',
      'INVESTIGATING',
      'IDENTIFIED',
      'MONITORING',
      'POSTMORTEM',
      'SLA',
      'UPTIME',
      'LATENCY',
      'THROUGHPUT',
      'ERROR_RATE',
      'SUCCESS_RATE',
      'AVG_RESPONSE',
      'P99_RESPONSE',
      'P95_RESPONSE',
      'CPU_USAGE',
      'MEMORY_USAGE',
      'DISK_USAGE',
      'NETWORK_IO',
      'DISK_IO',
      'OPEN_FILES',
      'THREAD_COUNT',
      'PROCESS_COUNT',
      'CONNECTIONS',
      'REQUESTS_PER_SEC',
      'ERRORS_PER_SEC',
      'TIMEOUTS_PER_SEC',
      'RETRIES_PER_SEC',
      'CACHE_HIT_RATE',
      'CACHE_MISS_RATE',
      'DB_CONNECTIONS',
      'DB_QUERIES',
      'DB_SLOW_QUERIES',
      'DB_ERRORS',
      'API_CALLS',
      'API_ERRORS',
      'API_LATENCY',
      'WEBHOOKS',
      'INTEGRATIONS',
      'WEBHOOK_URL',
      'API_KEY',
      'SECRET_KEY',
      'ACCESS_TOKEN',
      'REFRESH_TOKEN',
      'JWT_TOKEN',
      'OAUTH2',
      'BEARER',
      'BASIC_AUTH',
      'API_KEY_AUTH',
      'SESSION_ID',
      'CSRF_TOKEN',
      'XSRF_TOKEN',
      'COOKIE',
      'SET_COOKIE',
      'AUTHORIZATION',
      'CONTENT_TYPE',
      'ACCEPT',
      'USER_AGENT',
      'REFERER',
      'ORIGIN',
      'HOST',
      'X_FORWARDED_FOR',
      'X_REAL_IP',
      'X_REQUESTED_WITH',
      'IF_MODIFIED_SINCE',
      'IF_NONE_MATCH',
      'ETAG',
      'LAST_MODIFIED',
      'CACHE_CONTROL',
      'EXPIRES',
      'PRAGMA',
      'VARY',
      'ALLOW',
      'SERVER',
      'DATE',
      'CONTENT_LENGTH',
      'CONTENT_ENCODING',
      'TRANSFER_ENCODING',
      'CONNECTION',
      'KEEP_ALIVE',
      'UPGRADE',
      'PROXY_AUTHENTICATE',
      'PROXY_AUTHORIZATION',
      'TE',
      'TRAILER',
      'WARNING',
      'WWW_AUTHENTICATE',
      'ACCEPT_RANGES',
      'AGE',
      'DELETE',
      'GET',
      'HEAD',
      'OPTIONS',
      'PATCH',
      'POST',
      'PUT',
      'TRACE',
      'CONNECT',
      'HTTP/1.0',
      'HTTP/1.1',
      'HTTP/2',
      'HTTPS',
      'TLS',
      'SSL',
      'TCP',
      'UDP',
      'IP',
      'IPv4',
      'IPv6',
      'DNS',
      'DHCP',
      'FTP',
      'SFTP',
      'SSH',
      'TELNET',
      'SMTP',
      'POP3',
      'IMAP',
      'HTTP',
      'HTTPS',
      'WebSocket',
      'Socket.IO',
      'REST',
      'GraphQL',
      'SOAP',
      'XML',
      'JSON',
      'YAML',
      'TOML',
      'INI',
      'CSV',
      'TSV',
      'SQL',
      'NoSQL',
      'MongoDB',
      'PostgreSQL',
      'MySQL',
      'SQLite',
      'Redis',
      'Memcached',
      'Elasticsearch',
      'Solr',
      'Cassandra',
      'DynamoDB',
      'CouchDB',
      'Neo4j',
      'InfluxDB',
      'TimescaleDB',
      'ClickHouse',
      'Apache Kafka',
      'RabbitMQ',
      'Apache Pulsar',
      'NATS',
      'ZeroMQ',
      'ActiveMQ',
      'Amazon SQS',
      'Amazon SNS',
      'Google Pub/Sub',
      'Azure Service Bus',
      'Docker',
      'Kubernetes',
      'Docker Compose',
      'Helm',
      'Terraform',
      'Ansible',
      'Chef',
      'Puppet',
      'Jenkins',
      'GitLab CI',
      'GitHub Actions',
      'CircleCI',
      'Travis CI',
      'Bitbucket Pipelines',
      'AWS CodePipeline',
      'Azure DevOps',
      'GitLab',
      'GitHub',
      'Bitbucket',
      'Git',
      'SVN',
      'Mercurial',
      'Linux',
      'Windows',
      'macOS',
      'Unix',
      'BSD',
      'Android',
      'iOS',
      'React Native',
      'Flutter',
      'Ionic',
      'Xamarin',
      'Electron',
      'NW.js',
      'Node.js',
      'Deno',
      'Bun',
      'Python',
      'JavaScript',
      'TypeScript',
      'Java',
      'Kotlin',
      'C#',
      'C++',
      'C',
      'Go',
      'Rust',
      'Ruby',
      'PHP',
      'Swift',
      'Objective-C',
      'Scala',
      'Clojure',
      'Haskell',
      'Erlang',
      'Elixir',
      'F#',
      'R',
      'Julia',
      'Lua',
      'Perl',
      'Bash',
      'PowerShell',
      'Zsh',
      'Fish',
      'Shell',
      'Makefile',
      'CMake',
      'Gradle',
      'Maven',
      'npm',
      'yarn',
      'pnpm',
      'pip',
      'conda',
      'poetry',
      'cargo',
      'go mod',
      'composer',
      'gem',
      'bundler',
      'nuget',
      'pipenv',
      'virtualenv',
      'venv',
      'conda env',
      'docker build',
      'docker run',
      'docker ps',
      'docker images',
      'docker-compose up',
      'docker-compose down',
      'kubectl apply',
      'kubectl get',
      'kubectl describe',
      'kubectl logs',
      'kubectl exec',
      'helm install',
      'helm upgrade',
      'terraform init',
      'terraform plan',
      'terraform apply',
      'ansible-playbook',
      'chef-client',
      'puppet agent',
      'jenkins build',
      'gitlab-ci run',
      'gh actions run',
      'circleci build',
      'tris-ci build',
    ];

    const createCodeColumn = () => {
      const column = document.createElement('div');
      column.className = 'code-rain-column';
      
      const left = Math.random() * 100;
      const duration = 10 + Math.random() * 20;
      const delay = Math.random() * 5;
      const fontSize = 10 + Math.random() * 8;
      
      column.style.left = `${left}%`;
      column.style.animationDuration = `${duration}s`;
      column.style.animationDelay = `${delay}s`;
      column.style.fontSize = `${fontSize}px`;
      
      const codeLength = 5 + Math.floor(Math.random() * 15);
      let code = '';
      for (let i = 0; i < codeLength; i++) {
        code += codeSnippets[Math.floor(Math.random() * codeSnippets.length)] + '\n';
      }
      column.textContent = code;
      
      container.appendChild(column);
      
      // Remove column after animation completes
      setTimeout(() => {
        if (container.contains(column)) {
          container.removeChild(column);
        }
      }, (duration + delay) * 1000);
    };

    // Create initial columns
    for (let i = 0; i < 20; i++) {
      setTimeout(() => createCodeColumn(), i * 200);
    }

    // Continuously create new columns
    const interval = setInterval(() => {
      if (document.hidden) return;
      createCodeColumn();
    }, 500);

    return () => {
      clearInterval(interval);
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);

  return <div ref={containerRef} className="code-rain-container" />;
};

export default CodeRain;
